import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { AlertService } from '../alert/alert.service';
import { ErrorService } from '../errorbar/error.service';
import 'sipml';

@Injectable()
export class SipService {

  private user: any;
  private ua: any;
  public state: any;
  private testmode: boolean;

  private pickupPolicy: number;
  public PP = {
      RING: 0,
      AUTOACCEPT: 1,
      AUTOREJECT: 2,
  };


  private errorObserver = new Subject<any>();
  public onError = this.errorObserver.asObservable();

  private sipObserver = new Subject<any>();
  public onSipState = this.sipObserver.asObservable();

  constructor(private http: HttpClient, private alert: AlertService, private err: ErrorService) {
    this.initState();
    this.state.online = false;
    this.user = null;
  };

  public setSipUser(user) {
    this.user = user;
    this.deinitWebRtc();
  }

  private initState(): void {
    SIPml.init(function(){
        this.err.logError('debug', 'SipService: Done initialising SIP engine');
    }.bind(this), function(){
        this.err.logError('debug', 'SipService: Error initialising SIP engine');
    }.bind(this));
    //let remoteAudio = document.getElementById('audio');
    //if (remoteAudio && remoteAudio.hasOwnProperty('stop')) {
    //    remoteAudio['stop']();
    //    remoteAudio['srcObject'] = null;
    //}
    this.testmode = false;
    this.pickupPolicy = this.PP.AUTOACCEPT;
    this.state = {
        online: false,
        status: 'ready',
        permission: null,
        call: null,
        sip_session: null
    };
  }

  public setTestMode(testmode: boolean): void {
      this.testmode = testmode;
  }

  public initWebRtc(): any {
    if (!this.user || !this.user.hasOwnProperty('login')) {
        return false;
    }

    if (this.ua) {
        this.deinitWebRtc();
    }

    const iceServers = [
        {url: 'stun:stun.l.google.com:19302'},
        {url: 'stun:mangosip.ru:3478'},
        {url: 'turn:64.233.164.127:19305?transport=udp', username: 'CLProvUFEgbncZKu8RcYqvGggqMKIICjBQ', credential: 'FdHCgoYoL7xdRaZmGlHLIvoJYDI='},
        {url: 'turn:64.233.164.127:19305?transport=tcp', username: 'CLProvUFEgbncZKu8RcYqvGggqMKIICjBQ', credential: 'FdHCgoYoL7xdRaZmGlHLIvoJYDI='}
    ];

    const iceServersWL = [
        {url: 'stun:testpbx.winline.ru:3478'}
    ];

    const configuration: any = {
        realm: environment.SIP.HOST,
        impi: this.user.login,
        impu: 'sip:' + this.user.login + '@' + environment.SIP.HOST,
        password: this.user.password,
        display_name: this.user.login,
        websocket_proxy_url: environment.SIP.PROTOCOL + '://' + environment.SIP.HOST + environment.SIP.PATH,
        //outbound_proxy_url: 'udp://' + environment.SIP.HOST + ':5060',
        enable_rtcweb_breaker: false,
        events_listener: { events: '*', listener: this.onWebRtcStackEvent.bind(this) },
        sip_headers: [
            {name: 'User-Agent', value: 'CallCenter Workplace v0.2'}
        ]
    };
    if (location.search.indexOf('proxy=true') > -1) {
        configuration.ice_servers = iceServers;
    }
    if (location.search.indexOf('proxy=our') > -1) {
        configuration.ice_servers = iceServersWL;
    }

    this.state.online = false;
    this.ua = new SIPml.Stack(configuration);
    this.ua.addEventListener('started', this.onWebRtcConnect.bind(this))
    this.ua.addEventListener('i_new_call', this.onWebRtcInvite.bind(this))
    this.state.sip_session = Math.floor(999999 * Math.random());
    this.ua.o_stack.id = this.state.sip_session;
    this.err.logError('debug', 'SipService: starting SIP Session ' + this.state.sip_session);
    this.ua.start();
  }

  public deinitWebRtc(): void {
    this.err.logError('debug', 'SipService: deinit WebRtc');
    if (this.ua && this.ua.stop && this.state.status !== 'stopped') {
        this.err.logError('debug', 'SipService: stopping agent');
        this.ua.stop();
        this.ua = null;
        this.state.status = 'stopped';
    }
    this.state.online = false;
    this.state.sip_session = null;
  }

  public setPickupPolicy(policy: number): void {
      this.pickupPolicy = policy;
  }

  private publishWebRtc(): void {
     if (!this.ua) {
         return;
     }
     const presenceSession = this.ua.newSession('publish', {
         expires: 60,
         sip_headers: [
             { name: 'Event', value: 'presence' }
         ]
     });
     presenceSession.publish();
  }

  private onWebRtcConnect(): void {
     if (!this.ua) {
         return;
     }
     this.err.logError('debug', 'SipService: SIP Connection established');
     const regSession = this.ua.newSession('register', {
         expires: 0,
         events_listener: { events: '*', listener: this.onWebRtcSessionEvent.bind(this) },
         sip_caps: [
             {name: '+audio', value: null}
         ]
     });
     regSession.register();
  }

  private onWebRtcStackEvent(event: any): void {
     if (event) {
         if (!this.state.sip_session || (event.o_event.o_stack && event.o_event.o_stack.id !== this.state.sip_session)) {
             return;
         }
         this.err.logError('debug', 'SipService: WebRtc Stack Event: ' + event.type);
         switch(event.type) {
             case 'stopped':
                 this.err.logError('warn', 'SIP Connection lost, reconnecting...');
                 this.state.online = false;
                 this.state.status = 'stopped';
                 break;
             case 'm_permission_requested':
                 //this.err.logError('info', 'Необходимо разрешить использование микрофона');
                 this.state.permission = 'request';
                 this.sipObserver.next(this.state);
                 break;
             case 'm_permission_refused':
                 this.state.permission = 'error';
                 this.sipObserver.next(this.state);
                 this.rejectInvite();
                 //this.err.logError('error', 'Не получено разрешение на использование микрофона!');
                 break;
             case 'm_permission_accepted':
                 this.state.permission = null;
                 this.sipObserver.next(this.state);
                 break;
             default:
                 break;
         }
     }
  }

  private onWebRtcSessionEvent(event: any): void {
     this.err.logError('debug', 'SipService: WebRtc Session Event: ' + event.type);
     if (event && event.type.indexOf('_error') > -1) {
         this.err.logError('warn', 'SIP Session ' + event.type);
     }
     if (event) {
         switch(event.type) {
             case 'connected':
                 //this.err.logError('debug', 'SIP Registration successful');
                 // this.publishWebRtc();
                 this.state.online = true;
                 this.state.status = 'ready';
                 break;
             default:
                 break;
         }
     }
  }

  private onWebRtcCallEvent(event: any): void {
     this.err.logError('debug', 'SipService: WebRtc Call Event: ' + event.type);
     if (event && event.type === 'terminated') {
         this.state.status = 'ready';
         this.state.permission = null;
         this.state.call = null;
         this.sipObserver.next(this.state);
     }
  }

  private onWebRtcInvite(event: any): void {
     const call = event.newSession;
     this.err.logError('debug', 'SipService: Incoming Call');
     const remoteName = call.getRemoteUri();
     if (this.testmode && environment.SIP.ECHO_NUMBER && remoteName.indexOf(environment.SIP.ECHO_NUMBER) > -1) {
         this.err.logError('debug', 'SipService: Starting echo test');
         this.state.call = call;
         const acceptedEcho = this.state.call.accept({
             audio_remote: document.getElementById('audio'),
             events_listener: { events: '*', listener: this.onWebRtcCallEvent.bind(this) }
         });
         if (acceptedEcho != -1) {
             this.state.status = 'echo_test';
         } else {
             this.err.logError('debug', 'SipService: Could not start echo test');
         }
     } else {
         if (this.pickupPolicy === this.PP.AUTOACCEPT) {
             this.err.logError('debug', 'SipService: Accepting call');
             this.state.call = call;
             this.state.permission = null;
             const acceptedInvite = this.state.call.accept({
                 audio_remote: document.getElementById('audio'),
                 events_listener: { events: '*', listener: this.onWebRtcCallEvent.bind(this) }
             });
             if (acceptedInvite != -1) {
                 this.state.status = 'call_accepted';
                 this.pickupPolicy = this.PP.AUTOREJECT;
             } else {
                 this.state.status = 'call_aborted';
                 this.err.logError('debug', 'SipService: Could not accept call');
             }
         } else if (this.pickupPolicy === this.PP.AUTOREJECT) {
             // this.state.status = 'call_rejected';
             this.state.permission = null;
             const rejectedInvite = call.reject();
             if (rejectedInvite != -1) {
                 this.err.logError('error', 'SipService: Unexpected SIP Call (rejected)');
             } else {
                 this.err.logError('error', 'SipService: Unexpected SIP Call (error)');
             }
         } else {
             this.state.status = 'ringing';
         }
     }
     this.sipObserver.next(this.state);
  }

  public acceptInvite(): void {
      if (this.state.call !== null) {
          this.state.call.accept();
      }
  }

  public rejectInvite(): void {
      if (this.state.call !== null) {
          this.state.call.reject();
      }
  }

  public terminateCall(): void {
      this.err.logError('debug', 'SipService: Terminating call');
      if (this.state.call !== null) {
          this.err.logError('debug', 'SipService: Hangup');
          this.state.call.hangup();
          this.state.status = 'ready';
          this.sipObserver.next(this.state);
      }
  }

  public leaveIdleCall(): void {
      this.err.logError('debug', 'SipService: Leaving idle call');
      this.state.status = 'idle_call';
      this.sipObserver.next(this.state);
      if (this.state.call !== null) {
          this.err.logError('debug', 'SipService: Hangup');
          this.state.call.hangup();
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/sip/sip.service.ts